'use client';

import { useMemo } from 'react';
import { useUserCreditHistory } from '../api/queries/user-credit-history-queries';

export const useCalculateTotalAvailableCredit = (userId?: string) => {
  const { data, refetch } = useUserCreditHistory(userId);
  const totalAvailable = useMemo(
    () =>
      data?.credits
        ?.filter((credit) => !credit.expired)
        ?.reduce((acc, curr) => acc + curr.amount - curr.used, 0) || 0,
    [data?.credits],
  );

  return { totalAvailable, refetch };
};
